const findElement = (selector, root = document) => {
  return root.querySelector(selector);
};

const findElements = (selector, root = document) => {
  return root.querySelectorAll(selector);
};

const getDocumentMeta = (name) => {
  const element = findElement(`meta[name="${name}"]`, document.head);
  return element ? element.getAttribute('content') : null;
};

const removeElement = (el) => {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
};

const insertElement = (el, target, position) => {
  if (position === 'before') {
    target.parentNode.insertBefore(el, target);
  } else {
    target.parentNode.insertBefore(el, target.nextSibling);
  }
};

export {findElement, findElements, getDocumentMeta, removeElement, insertElement};
